// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"594":"about","652":"service","797":"industry"}[chunkId] || chunkId) + "." + {"137":"ed0dc546","594":"db3d334f","652":"339090d7","797":"53338d93"}[chunkId] + ".js";
};